import { Component, inject, PLATFORM_ID, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Navbar } from '../../shared/components/layout/navbar/navbar';
import { Footer } from '../../shared/components/layout/footer/footer';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Masks} from '../../shared/utils/masks';
import { MaskitoDirective } from '@maskito/angular';
import { InputTextModule } from 'primeng/inputtext';
import { isPlatformBrowser } from '@angular/common';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { SeoManager } from '../../core/services/seo/seo-manager';

export type contactType = 'product' | 'services' | 'pqr';

@Component({
  selector: 'app-contact',
  imports: [Navbar, Footer, ReactiveFormsModule, FormsModule, CommonModule, MaskitoDirective, InputTextModule],
  templateUrl: './contact.html',
  styleUrl: './contact.scss',
})
export class Contact implements AfterViewInit, OnDestroy {
  private platformId = inject(PLATFORM_ID);
  private scrollSmoother: ScrollSmoother | null = null;
  private seoManager = inject(SeoManager);

  @ViewChild('smoothWrapper', { static: false }) smoothWrapper!: ElementRef<HTMLDivElement>;
  @ViewChild('smoothContent', { static: false }) smoothContent!: ElementRef<HTMLDivElement>;

  masks = Masks;

  contactForm!: FormGroup;

  contact_type: contactType = 'product';

  constructor() {
    this.seoManager.updateSeoTags({
      title: 'Contacto',
      description: 'Contacte con nosotros para obtener más información sobre nuestro producto.',
    });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
      this.initScrollSmoother();
    }
  }

  ngOnDestroy() {
    if (this.scrollSmoother) {
      this.scrollSmoother.kill();
    }
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  }

  private initScrollSmoother() {
    if (!this.smoothWrapper?.nativeElement || !this.smoothContent?.nativeElement) {
      return;
    }

    this.scrollSmoother = ScrollSmoother.create({
      wrapper: this.smoothWrapper.nativeElement,
      content: this.smoothContent.nativeElement,
      smooth: 1.5,
      effects: true,
      smoothTouch: 0.1,
    });
  }

  selectContactType(contactType: contactType) {
    this.contact_type = contactType;
    this.contactForm.reset();
    if (contactType == 'product' || contactType == 'services') {
      if(!this.contactForm.contains('organization_name') && !this.contactForm.contains('users_qt')) {
        this.contactForm.addControl('organization_name', new FormControl('', [Validators.required]));
        this.contactForm.addControl('users_qt', new FormControl('', [Validators.required]));
      }
    } else {
      this.contactForm.removeControl('organization_name');
      this.contactForm.removeControl('users_qt');
    }
  }

  submitContact() {

  }
}
